<template>
    <div id="material">
        <div class="info title clearfix" :style="[ !img ? {background: '#333'} : {background: 'url(' + img + ')'}]">
            <div class="wrapper clearfix">
                <div class="col-xs-120">
                    <h1>{{title}}</h1>
                </div>
            </div>
        </div>
        <div class="info text clearfix" style="width: 100%;">
            <div class="wrapper">
                <div class="col-xs-120 no-padding wrapper" >
                    <v-runtime-template class="text" :template="text"/>
                </div>
            </div>
        </div>
        <articles/>
    </div>
</template>

<script>
import axios from '@/router/http'
import VRuntimeTemplate from 'v-runtime-template'
export default {
  name: 'Material',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      title: null,
      img: null,
      text: null
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-get-article?link=' + window.location.pathname).then(response => {
      this.title = response.data.title
      this.img = response.data.img
      this.text = '<div>' + response.data.text.replace(/{form_application}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_cat}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_shinomontag}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_avtourist}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_sravni_osago}/gi, '<osago-form/>').replace(/{form_sravni_kasko}/gi, '<kasko-form/>').replace(/{form_sokr}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_karta}/gi, '<texosmotr-form/>').replace(/{/gi, '').replace(/}/gi, '').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('[.]{2}/[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('"uploads', 'g'), '"/static/uploads').replace(new RegExp('\'uploads', 'g'), '\'/static/uploads') + '</div>'
    }) // .replace(new RegExp('<a', 'g'), '<router-link').replace(new RegExp('</a>', 'g'), '</router-link>').replace(new RegExp('href', 'g'), 'to')
  },
  watch: {
    $route (to, from) {
      axios.get('https://crm.v-avtoservice.com/list/site-get-article?link=' + to.path).then(response => {
        this.title = response.data.title
        this.img = response.data.img
        this.text = '<div>' + response.data.text.replace(/{form_application}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_cat}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_shinomontag}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_avtourist}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_sravni_osago}/gi, '<osago-form/>').replace(/{form_sravni_kasko}/gi, '<kasko-form/>').replace(/{form_sokr}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_karta}/gi, '<texosmotr-form/>').replace(/{/gi, '').replace(/}/gi, '').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/frontend/public', 'g'), '/static').replace(new RegExp('frontend/public', 'g'), '/static').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('[.]{2}/[.]{2}/[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('[.]{2}/[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('[.]{2}/uploads', 'g'), '/static/uploads').replace(new RegExp('"uploads', 'g'), '"/static/uploads').replace(new RegExp('\'uploads', 'g'), '\'/static/uploads') + '</div>'
      }) // .replace(new RegExp('<a', 'g'), '<router-link').replace(new RegExp('</a>', 'g'), '</router-link>').replace(new RegExp('href', 'g'), 'to')
    }
  },
  components: {
    VRuntimeTemplate
  }
}
</script>

<style scoped>
.info.title {
    background-repeat: no-repeat !important;
    background-color: #393939 !important;
    background-position-y: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Material.vue